module.exports = __webpack_public_path__ + "static/transparency_icon-185320d9d5d4bd16a77fd65034cddab6.png";